import React from 'react';
import PropTypes from 'prop-types';
import { scrollToElement } from 'core/utils/helpers/scrollToElement';
import FavoriteIcon from 'core/modules/FavoriteIcon/FavoriteIcon';
import PremierMerchantRebate from 'core/modules/PremierMerchantRebate/PremierMerchantRebate';
import ExtraRewardsPill from 'core/modules/ExtraRewardsPill/ExtraRewardsPill';
import MerchantClickUrlLink from 'core/modules/MerchantClickUrlLink/MerchantClickUrlLink';

import './MerchantInfoTile.scss';

function MerchantInfoTile({ merchant, config, descriptionRef }) {
  const {
    id, name, logoUrls, rebate, isDirect, showRebate,
  } = merchant;
  const { rebateOptions, directMerchantCTA, directMerchantName } = config;
  const label = isDirect ? `${showRebate ? 'Shop with' : 'Save with'} ${directMerchantCTA}` : 'Shop now';

  const handleScrollButton = () => {
    scrollToElement(descriptionRef.current);
  };

  if (!id) {
    return null;
  }

  return (
    <div className="mn_merchantInfoTile" data-test="merchant-info-tile">
      {isDirect && <div className="mn_directMerchantLogo">{directMerchantName}</div>}
      <FavoriteIcon
        merchantId={id}
        merchantName={name}
        secondaryTooltipEnabled
        isSecondaryTooltipPermanentForUnfavorited
        secondaryLabelUnfavorited="Is this store your favorite?"
        tooltipClassName="mn_merchantInfoTileTooltip"
      />
      <img className="mn_logo" src={logoUrls._120x60} alt={name} />
      <ExtraRewardsPill rebate={rebate} />
      {showRebate && <PremierMerchantRebate {...rebate} {...rebateOptions} />}
      <MerchantClickUrlLink className="mn_button mn_shopNowLink" merchant={merchant} defaultLabel={label} />
      <button type="button" className="mn_scrollButton" onClick={handleScrollButton}>
        View store exclusions, terms & conditions, and more
      </button>
    </div>
  );
}

MerchantInfoTile.propTypes = {
  merchant: PropTypes.shape({}).isRequired,
  config: PropTypes.shape({}).isRequired,
};

export default MerchantInfoTile;
